var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    fill: "none",
    viewBox: "0 0 14 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M10.172 7.586a.575.575 0 0 1-.813-.813l2.114-2.114H1.146a.575.575 0 1 1 0-1.149H11.46l-2.1-2.1a.575.575 0 1 1 .812-.813l3.088 3.088a.575.575 0 0 1 0 .813z"
  })));
};
export default SvgChevronRight;